import React, { useEffect, useState } from "react";
import CustomAddActionCard from "../../../common/components/CustomAddActionCard/CustomAddActionCard";
import CardContentActionTile from "../../../common/components/CardContentActionTile/CardContentActionTile";
import { Box } from "@mui/system";
import CustomEditCard from "../../../common/components/CustomEditCard/CustomEditCard";
import TopPerformerTile from "../../../common/components/TopPerformerTile/TopPerformerTile";

interface propsType {
  trans?: any;
}
const TopPerformerPresenter: React.FC<propsType> = ({ trans }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);

  return (
    <div>
      <CustomEditCard
        card_title={trans("Top 3 Performer")}
        card_height="310px"
        showEditButton={false}
      >
        <Box style={{ marginBottom: "24px" }} />

        <div>
          <TopPerformerTile
            designation="UX Designer"
            name="Axial Khan"
            pic=""
            value={95}
          />
          <Box marginTop={"0.5em"} />
          <TopPerformerTile
            designation="UX Designer"
            name="Axial Khan"
            pic=""
            value={95}
          />
          <Box marginTop={"0.5em"} />
          <TopPerformerTile
            designation="UX Designer"
            name="Axial Khan"
            pic=""
            value={95}
          />
        </div>
      </CustomEditCard>

      {/* Add Employee Skill Modal */}
    </div>
  );
};

export default TopPerformerPresenter;
